import { beforeEnterMicrofrontend } from '@/router/routes/business/inventory/utils/beforeEnterMicrofrontend'

export default [
  {
    path: ':path(usages.*)?',
    name: 'inventory.usages',
    beforeEnter: beforeEnterMicrofrontend('usages'),
    component: () => import('@/views/business/inventory/usages/iframe-service.vue'),
  },
]
